export default __webpack_public_path__ + "static/media/mc_open_vector.3f94df86.svg";